import { atomFamily } from 'jotai/utils';
import BaseAtomFactory from './BaseAtomFactory';

const BaseAtomFamilyFactory = function (operations, options) {
    const baseAtomFamily = atomFamily((key) => new BaseAtomFactory(operations, key, options));
    return baseAtomFamily;
};

export default BaseAtomFamilyFactory;